import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServiceErpService {

  constructor(private http : HttpClient) { }

  getAllProjects(){
    return this.http.get('/api/numberAllProjects')
  }
  getAllDirectives(){
    return this.http.get('/api/numberAllDirectives')
  }
  getAllProcedures(){
    return this.http.get('/api/numberAllProcedures')
  }
  getProjectsByStatus(valoare){
    return this.http.get(`/upsell/numberProjectsByStatus?statusProject=${valoare}`)
  }
  getDirectiveByStatus(valoare){
    return this.http.get(`/upsell/numberDirectiveByStatus?statusDirective=${valoare}`)
  }
  getProcedureByStatus(valoare){
    return this.http.get(`/upsell/numberProcedureByStatus?statusProcedure=${valoare}`)
  }
}
